export const getTaxonomyBasePath = () => '/taxonomy';

export const buildTaxonomyListPath = () => getTaxonomyBasePath();

export const buildTaxonomyFeedbackPath = (
  taxonomyAlias: string,
) => `${getTaxonomyBasePath()}/${taxonomyAlias}/feedback`;

export const buildTaxonomyTopicPath = (
  taxonomyAlias: string,
  topicAlias: string,
) => `${getTaxonomyBasePath()}/${taxonomyAlias}/topic/${topicAlias}`;

export const buildWorkspaceTaxonomyPath = (
  workspaceAlias: string,
  relativeTaxonomyPath: string,
) => `/workspace/${workspaceAlias}${relativeTaxonomyPath}`;
